import React, { useEffect, useState } from 'react'
import {
  CBadge,
  CCard,
  CCardBody,
  CCol,
  CDropdown,
  CDropdownToggle,
  CDropdownMenu,
  CDropdownItem,
  CRow,
  CSmartTable,
} from '@coreui/react-pro'
import CIcon from '@coreui/icons-react'
import {
  cilCheckCircle,
  cilDescription,
  cilOptions,
  cilPeople,
  cilSpreadsheet,
} from '@coreui/icons'

import moment from 'moment'
import { useNavigate } from 'react-router-dom'
import FixtureService from 'src/service/FixtureService'
import CommonService from 'src/service/CommonService'

const CompletedFixture = () => {
  const [loading, setLoading] = useState(false)
  const [activePage, setActivePage] = useState(1)
  const [columnFilter, setColumnFilter] = useState([])
  const [columnSorter, setColumnSorter] = useState(null)
  const [itemsPerPage, setItemsPerPage] = useState(100)
  const [users, setUsers] = useState({})
  const navigate = useNavigate()
  const [gameType, setGameType] = useState()

  useEffect(() => {
    CommonService.getGameType().then((res) => {
      if (res.status === 200) {
        setGameType(res.data)
      }
    })
  }, [])

  var columns = [
    {
      label: 'FID',
      key: 'id',
      _style: { width: '10%' },
    },
    {
      key: 'round',
    },
    {
      label: 'Team Name',
      key: 'team_name',
    },
    { label: 'Match Type', key: 'match_type' },
    { label: 'Start Date', filter: false, key: 'start_date' },
    { label: 'Status', filter: false, key: 'status' },
    { label: 'Finalized', filter: false, key: 'updated_at' },
    {
      key: 'show_details',
      label: 'Actions',
      _style: { width: '1%' },
      filter: false,
      sorter: false,
    },
  ]

  if (gameType !== 1) {
    columns = [
      {
        label: 'FID',
        key: 'id',
        _style: { width: '10%' },
      },
      {
        key: 'round',
      },
      {
        label: 'Home Team',
        key: 'team_name',
      },
      {
        label: 'Away Team',
        key: 'team2_name',
      },
      { label: 'Match Type', key: 'match_type' },
      { label: 'Start Date', filter: false, key: 'start_date' },
      { label: 'Status', filter: false, key: 'status' },
      { label: 'Finalized', filter: false, key: 'updated_at' },
      {
        key: 'show_details',
        label: 'Actions',
        _style: { width: '1%' },
        filter: false,
        sorter: false,
      },
    ]
  }

  useEffect(() => {
    setLoading(true)
    const offset = itemsPerPage * activePage - itemsPerPage
    let params = new URLSearchParams()
    Object.keys(columnFilter).forEach((key) => {
      params.append(key, columnFilter[key])
    })
    columnSorter &&
      columnSorter.column !== undefined &&
      params.append('sort', `${columnSorter.column}%${columnSorter.state}`)

    FixtureService.getCompletedFixture(offset, itemsPerPage, activePage, params).then((result) => {
      setUsers(result.data)
      setLoading(false)
    })
  }, [activePage, columnFilter, columnSorter, itemsPerPage])

  return (
    <>
      <CRow className="g-3 mb-3">
        <CCol sm={6} lg={4}>
          <CCard className="h-100">
            <CCardBody className="d-flex justify-content-between align-items-center">
              <div>
                <div className="text-medium-emphasis small">Total Completed</div>
                <div className="fs-4 fw-semibold">{users?.total ?? 0}</div>
              </div>
              <div
                className="d-flex align-items-center justify-content-center rounded-circle"
                style={{
                  width: 42,
                  height: 42,
                  backgroundColor: 'rgba(var(--cui-success-rgb), 0.12)',
                  color: 'var(--cui-success)',
                }}
              >
                <CIcon icon={cilCheckCircle} size="lg" />
              </div>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>

      <CCard>
        <CCardBody>
          <div className="ge-datatable ge-datatable--static">
            <CSmartTable
              columns={columns}
              noItemsLabel="No completed fixtures found"
              columnFilter={{
                external: true,
              }}
              columnSorter={{
                external: true,
              }}
              scopedColumns={{
                status: () => (
                  <td>
                    <CBadge color="success" shape="rounded-pill" className="px-2 py-1">
                      Completed
                    </CBadge>
                  </td>
                ),
                start_date: (item) => <td>{moment(item.start_date).format('D.MM.YYYY')}</td>,
                updated_at: (item) => (
                  <td>
                    {moment(item.updated_at).format('D.MM.YYYY')},{' '}
                    {moment(item.updated_at).format('h:mm A')}
                  </td>
                ),
                show_details: (item) => (
                  <td className="py-2">
                    <CDropdown alignment="end" placement="bottom-end" portal>
                      <CDropdownToggle color="transparent" caret={false} className="p-0">
                        <CIcon icon={cilOptions} role="button" />
                      </CDropdownToggle>
                      <CDropdownMenu className="ge-row-actions-menu">
                        <CDropdownItem
                          role="button"
                          onClick={() => navigate(`/completed-fixtures/show-scorecard/${item.id}`)}
                        >
                          <CIcon icon={cilDescription} className="me-2" />
                          View Scorecard
                        </CDropdownItem>
                        <CDropdownItem
                          role="button"
                          onClick={() => navigate(`/completed-fixtures/show-squads/${item.id}`)}
                        >
                          <CIcon icon={cilPeople} className="me-2" />
                          View Squad
                        </CDropdownItem>
                        <CDropdownItem
                          role="button"
                          onClick={() =>
                            navigate(`/completed-fixtures/manage-scorecard/${item.id}`)
                          }
                        >
                          <CIcon icon={cilSpreadsheet} className="me-2" />
                          Manage Details
                        </CDropdownItem>
                      </CDropdownMenu>
                    </CDropdown>
                  </td>
                ),
              }}
              items={users?.data}
              itemsPerPage={itemsPerPage}
              itemsPerPageSelect
              loading={loading}
              pagination={{
                external: true,
              }}
              paginationProps={{
                activePage: activePage,
                pages: Math.ceil(users?.total / itemsPerPage) || 1,
              }}
              tableProps={{
                hover: true,
                responsive: true,
                className: 'align-middle mb-0',
              }}
              onActivePageChange={(activePage) => setActivePage(activePage)}
              onColumnFilterChange={(filter) => {
                setActivePage(1)
                setColumnFilter(filter)
              }}
              onItemsPerPageChange={(itemsPerPage) => {
                setActivePage(1)
                setItemsPerPage(itemsPerPage)
              }}
              onSorterChange={(sorter) => setColumnSorter(sorter)}
            />
          </div>
        </CCardBody>
      </CCard>
    </>
  )
}

export default CompletedFixture
